module.exports = "img/fileicon.a04644a.png";